import { SignUpForm } from '../sign-up/sign-up-form';

export const SectionSignUp = () => {
  return (
    <section className="w-full py-12 md:py-24 lg:py-28 bg-gray-100 dark:bg-gray-800">
      <div className="container px-4 md:px-6">
        <div className="text-center space-y-2 mb-12">
          <h2 className="text-4xl font-bold tracking-tighter sm:text-5xl text-center">
            Ready to Switch to Liquid Budget?
          </h2>
          <p className="text-2xl md:text-3xl text-muted-foreground">Join the others and start saving today.</p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="bg-card border-2 border-primary/20 rounded-xl  shadow-lg">
            <SignUpForm />
          </div>
        </div>
      </div>
    </section>
  );
};
